var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotifyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1328_1386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4993 0.0429688C6.34171 0.0429688 0.539062 5.84546 0.539062 13.003C0.539062 20.1609 6.34171 25.963 13.4993 25.963C20.6577 25.963 26.4597 20.1609 26.4597 13.003C26.4597 5.84592 20.6577 0.0435878 13.4991 0.0435878L13.4993 0.0429688ZM19.4428 18.7351C19.2106 19.1158 18.7123 19.2365 18.3316 19.0028C15.2886 17.1442 11.458 16.7232 6.94667 17.7539C6.51194 17.853 6.07861 17.5806 5.97956 17.1457C5.88005 16.7108 6.15135 16.2775 6.58716 16.1784C11.5241 15.0501 15.7588 15.5362 19.175 17.6239C19.5557 17.8576 19.6765 18.3544 19.4428 18.7351ZM21.0291 15.2058C20.7366 15.6817 20.1144 15.8318 19.6393 15.5393C16.1556 13.3975 10.8453 12.7774 6.72474 14.0282C6.19035 14.1896 5.62593 13.8884 5.46374 13.355C5.30279 12.8206 5.60411 12.2572 6.13758 12.0947C10.8444 10.6666 16.6957 11.3584 20.6963 13.8168C21.1715 14.1093 21.3216 14.7314 21.0291 15.2059V15.2058ZM21.1653 11.5311C16.9882 9.05011 10.0967 8.82199 6.10864 10.0324C5.46823 10.2266 4.79099 9.86509 4.59692 9.22468C4.40285 8.58397 4.76406 7.90719 5.40493 7.7125C9.98295 6.32274 17.5934 6.59125 22.4024 9.44615C22.9797 9.78802 23.1685 10.532 22.8265 11.1072C22.486 11.6832 21.7401 11.8731 21.1659 11.5311H21.1653Z",
    fill: "#1ED760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1328_1386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyIcon);
export default __webpack_public_path__ + "static/media/spotify_icon.7315d27ac39e926856d67672f733e982.svg";
export { ForwardRef as ReactComponent };